import BezierEasing from 'bezier-easing';

interface StateFrame {
  x?: number;
  y?: number;
  scale?: number;
  // pivotX?: number;
  // pivotY?: number;
  rotation?: number;
  alpha?: number;
  toAlpha?: number;
}
export class IFTTTAnimation {
  shapeId: string;
  type: IAnimation['type'];

  status: 'waiting' | 'in-progress' | 'completed' = 'waiting';
  private startAt = Date.now();
  private easing = BezierEasing(0, 0, 1, 1);
  private delay = 0;
  private duration = 300;

  private toState: StateFrame = {};
  private fromState: StateFrame = {};
  private _currEasingVal = 0;

  constructor(
    shapeId: string,
    type: IFTTTAnimation['type'],
    config: {
      easing: BezierEasing.EasingFunction;
      duration: number;
      delay: number;
      toState: StateFrame;
      fromState?: StateFrame;
    }
  ) {
    this.shapeId = shapeId;
    this.type = type;
    this.reset(config);
  }

  reset(config: ConstructorParameters<typeof IFTTTAnimation>[2]) {
    const {
      easing = BezierEasing(0, 0, 1, 1),
      duration,
      delay = 0,
      toState = {},
      fromState = {}
    } = config;
    this.easing = easing;
    if (!duration) throw '动画duration不可为0';
    this.duration = duration;
    this.delay = delay;

    this.status = 'waiting';
    this._currEasingVal = 0;
    this.toState = { ...toState };
    this.fromState = { ...fromState };
  }

  next() {
    if (this.status == 'waiting') {
      this.startAt = Date.now();
      this.status = 'in-progress';
    }
    if (this.status == 'completed') return;
    const easingValue = this.getCurrEasingValue();
    this._currEasingVal = easingValue;
  }

  private getCurrFrameState(fromState: StateFrame) {
    const { scale: scale0 = 1, rotation: rotation0 = 0 } = fromState;

    const { alpha = 1 } = this.fromState;
    const {
      toAlpha = 1,
      scale = 0,
      // pivotX = 0,
      // pivotY = 0,
      rotation = 0,
      x = 0,
      y = 0
    } = this.toState;

    const easingValue = this._currEasingVal;
    return {
      alpha: alpha + (toAlpha - alpha) * easingValue,
      toAlpha: easingValue * toAlpha,
      scale: easingValue * (scale - scale0),
      // pivotX,
      // pivotY,
      rotation: easingValue * (rotation - rotation0),
      x: easingValue * x,
      y: easingValue * y
    };
  }

  private getCurrEasingValue() {
    const { startAt, duration, easing, delay = 0 } = this;
    const _offset = Date.now() - startAt - delay;
    if (_offset < 0) return 0;
    const _time = _offset / duration;
    const _easing = _time > 1 ? 1 : easing(_time);
    if (_time >= 1) this.status = 'completed';
    return _easing;
  }

  getFrameValue(from: StateFrame): StateFrame {
    const type = this.type;

    const {
      rotation: rotation0 = 0,
      scale: scale0 = 1
      // alpha: alpha0 = 1
    } = from;
    const {
      rotation = 0,
      // pivotX = 0,
      // pivotY = 0,
      scale = 0,
      alpha = 1,
      toAlpha = 1,
      x = 0,
      y = 0
    } = this.getCurrFrameState(from);

    if (type == 'position') {
      return {
        x: Math.floor(x),
        y: Math.floor(y)
      };
    } else if (type == 'rotation') {
      return {
        rotation: rotation0 + rotation
        // pivotX,
        // pivotY
      };
    } else if (type == 'scale') {
      return {
        scale: Math.max(0, scale0 + scale)
        // pivotX,
        // pivotY
      };
    } else if (type == 'alpha') {
      return {
        alpha: Math.max(0, Math.min(1, alpha)),
        toAlpha: Math.max(0, Math.min(1, toAlpha))
      };
    } else {
      return from;
    }
  }
}
